<section class="pt-16 pb-8 px-container">
    <app-breadcrumb-backoffice [items]="[{ label: 'Home', route: '/backoffice/home' }, { label: 'Vouchers', route: '/backoffice/vouchers' }]"></app-breadcrumb-backoffice>
    <h1 class="lg:text-4xl text-2xl font-mono text-center uppercase">Vouchers</h1>
</section>

<section class="pb-16 mb-8 px-container">

    <p-table #dt
        [exportFilename]="'vouchers'"
        [columns]="[{field: 'cliente', header: 'Cliente'}, {field: 'email', header: 'Email'}, {field: 'telefono', header: 'Telefono'}, {field: 'codice', header: 'Codice'}, {field: 'credito', header: 'Credito'}, {field: 'data_scadenza', header: 'Data scadenza'}, {field: 'data_creazione', header: 'Data creazione'}]"
        [loading]="loading" [value]="vouchers" responsiveLayout="stack" [breakpoint]="'960px'"
        styleClass="p-datatable-striped" [paginator]="true" [showCurrentPageReport]="true" [rowHover]="true"
        [globalFilterFields]="['cliente', 'email', 'codice']"
        currentPageReportTemplate="{first} di {last} su {totalRecords} vouchers" [rows]="5"
        [rowsPerPageOptions]="[5, 10, 20, 50, 100]">
        <ng-template pTemplate="caption">
            <div class="flex lg:flex-row flex-col gap-8">
                <span class="block lg:w-1/4 w-full p-input-icon-left">
                    <i class="bi bi-search before:align-super before:content-['\f52a']"></i>
                    <input pInputText type="text" (input)="onGlobalFilter(dt, $event)" placeholder="Cerca..." class="w-full indent-6" />
                </span>
                <span class="lg:w-2/4 w-full lg:block hidden"></span>
                <span class="lg:w-1/4 w-full flex lg:flex-row flex-col gap-2">
                    <button type="button" class="text-center btn-outln-backoffice p-2 py-[0.75rem] w-full font-medium" (click)="dt.exportCSV()">Esporta</button>
                    <button type="button" class="text-center btn-outln-backoffice p-2 py-[0.75rem] w-full font-medium" routerLink="/backoffice/vouchers/add">Aggiungi</button>
                </span>
            </div>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th pSortableColumn="cliente" class="w-1/6">Cliente <span class="inline-flex"><p-sortIcon field="cliente" /></span></th>
                <th pSortableColumn="email" class="w-1/6">Email <span class="inline-flex"><p-sortIcon field="email" /></span></th>
                <th pSortableColumn="codice" class="w-1/6">Codice <span class="inline-flex"><p-sortIcon field="codice" /></span></th>
                <th pSortableColumn="credito" class="w-1/6">Credito <span class="inline-flex"><p-sortIcon field="credito" /></span></th>
                <th pSortableColumn="data_scadenza" class="w-1/6">Data scadenza <span class="inline-flex"><p-sortIcon field="data_scadenza" /></span></th>
                <th class="w-1/6 text-center">Azioni</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-voucher>
            <tr>
                <td><span class="p-column-title">Cliente</span>{{voucher.cliente | titlecase}}</td>
                <td><span class="p-column-title">Email</span>{{voucher.email | lowercase}}</td>
                <td><span class="p-column-title">Codice</span>{{voucher.codice}}</td>
                <td><span class="p-column-title">Credito</span>{{voucher.credito | currency: 'EUR' }}</td>
                <td><span class="p-column-title">Data Scadenza</span>{{voucher.data_scadenza | date: 'dd/MM/yyyy' }}</td>
                <td class="md:justify-center justify-between flex"><span class="p-column-title">Azioni</span>

                    <div class="flex flex-row items-center justify-center">
                        <i class="bi bi-pencil lg:text-3xl text-2xl hover:text-accent cursor-pointer" [routerLink]="'/backoffice/vouchers/' + voucher.id"></i>
                        <p-divider layout="vertical"></p-divider>
                        <p-confirmPopup #deleteVoucher>
                            <ng-template pTemplate="headless" let-message>
                                <div class="border-round p-3">
                                    <span class="text-base">{{ message.message }}</span>
                                    <div class="flex align-items-center gap-2 mt-3">
                                        <button type="button" class="text-center btn-danger-backoffice p-2 w-full font-medium" (click)="onDeleteVoucher()">Elimina</button>
                                        <button type="button" class="text-center btn-outln-backoffice p-2 w-full font-medium" (click)="onAnnullaDeleteVoucher()">Annulla</button>
                                    </div>
                                </div>
                            </ng-template>
                        </p-confirmPopup>

                        <i class="bi bi-trash lg:text-3xl text-2xl hover:text-accent cursor-pointer" (click)="onOpenDeleteVoucher($event, voucher)"></i>
                    </div>

                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="6">Nessun voucher trovato.</td>
            </tr>
        </ng-template>
    </p-table>
</section>